;(function($) {
	'use strict';

	$(document).ready(function () {
		var subheaders = $(".subheader-rotation");
		var current = 0;
		var next = 1;

		function loopyCycler() {
			animateSubHeader( function() {
				setTimeout( loopyCycler, 3000 );
			});
		}

		function animateSubHeader(done) {
			$('.rotation-'+current).fadeOut(500, function() {
				var text = $('.rotation-'+next).text();
				$('.rotation-'+next).text('');
				typeWriterSlower($('.rotation-'+next), text, 0);

				$('.rotation-'+next).fadeIn(500, done);



				current = next;

				next++;
				if(next >= subheaders.length) {
					next = 0;
				}

			});
		}
		
		function typeWriterSlower(current_class, value, iteration) {
			if (iteration === value.length)
				return;

			setTimeout(function() {
				$(current_class).text( $(current_class).text() + value[iteration++] );

				typeWriterSlower(current_class, value, iteration);
			}, 80);
		}

		loopyCycler();

		
		
	});
})(jQuery, window, document);